export default __webpack_public_path__ + "static/media/ipermitIcon.70b09e56.svg";